import React from 'react';

import { ProfileLayout } from '../../components/profile/layout';
import { Qualifications } from '../../components/profile/qualifications';
import { initializeApollo } from '../../lib/auth/apollo';
import { getNav } from '../../lib/get-nav';

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  await getNav(apolloClient);

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
    },
    revalidate: 100,
  };
}

const Profile = () => {
  return (
    <ProfileLayout pageTitle="Qualifications">
      <Qualifications />
    </ProfileLayout>
  );
};

Profile.propTypes = {
  menuItems: ProfileLayout.propTypes.navItems,
};

export default Profile;
